import styled from 'styled-components';

export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
  .provision-container {
    display: flex;
    flex-direction: row;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 60px;
    padding: 30px;
    box-shadow: inset 0px -3px 0px #0075c9;
    border-radius: 4px 0px 4px 4px;
  }
  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    color: #8b8b8b;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .value {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #2b2727;
  }
  .status {
    width: 120px;
    height: 28px;
    left: 0px;
    top: 19px;
    background: rgba(252, 183, 24, 0.12);
    border: 1.3px solid #fcb718;
    box-sizing: border-box;
    border-radius: 100px;
  }
  .status-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 25px;
    margin-left: 25px;
    text-transform: uppercase;
  }
  .riskBloc {
    width: 100%;
    height: 47px;
    left: 0px;
    top: 0px;
    background: linear-gradient(
      0deg,
      rgba(8, 128, 188, 0.1),
      rgba(8, 128, 188, 0.1)
    );
    border-radius: 4px 4px 0px 0px;
    margin-top: 30px;
    padding-top: 15px;
    padding-left: 5px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #2b2727;
  }
  .globalProvisionBloc {
    width: 100%;
    height: 47px;
    left: 0px;
    top: 0px;
    background: rgba(252, 183, 24, 0.1);
    border-radius: 4px 4px 0px 0px;
    margin-top: 30px;
    padding-top: 15px;
    padding-left: 5px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #2b2727;
  }
  .headerTitle {
    background: #f8f8f8;
    box-shadow: inset 0px -1px 0px #ecefee;
    border-radius: 0px 4px 0px 0px;
  }
  .riskInfo {
    font-weight: bold;
  }
  .row {
    &:hover {
      cursor: pointer;
      background-color: #e8f8ff;
    }
  }
  .navContainer {
    display: flex;
    flex-direction: rows;
  }
  .nav {
    background: #e6e9ed;
    border-radius: 4px 0px 0px 4px;
    width: 100%;
  }
  .header {
    width: 153px;
    height: 32px;
    left: 16px;
    top: 64px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    padding-top: 7px;
    color: #0075c9;
    &:hover {
      cursor: pointer;
    }
  }
  .subHeader {
    width: 294px;
    height: 32px;
    left: 169px;
    top: 64px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding-top: 7px;
    text-align: center;
    color: #373839;
  }
  .evalManuel {
    display: inline;
    float: right;
    width: 200px;
    height: 16px;
    left: 29px;
    top: 16px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #0075c9;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 11px 0px 10px;
  gap: 10px;
  .nav {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
    cursor: pointer;
    &:disabled {
      background-color: grey;
    }
  }
`;

export const ActionButton = styled.button`
  margin-top: 10px;
  height: 40px;
  padding: 10px;
  background: #0074c9;
  border-radius: 4px;
  .validate {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    width: 100%;
    color: #fff;
  }
`;

export const StyledSpan = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #0074c9;
  cursor: pointer;
`;

export const StyledRecapTitle = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  padding-top: 8px;
  padding-bottom: 8px;
`;
export const StyledItemTitle = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
`;
export const StyledBeneficiaryTitle = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #8b8b8b;
`;
interface StyledRecapDataProps {
  isColored: boolean;
}
export const StyledRecapData = styled.span<StyledRecapDataProps>`
  display: block;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  align-items:center;
  color:${({ isColored }) => (isColored ? 'rgba(9, 122, 194, 1);' : '#8e8e8e;')}
  
  .section {
    justify-content: flex-start;
    flex-direction: column;
    display: flex;
    line-height: 0px;
  }
  
`;
export const StyledDeceasedData = styled.span`
  display: block;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  align-items: center;
`;
export const StyledData = styled.span`
  display: block;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 0px 20px 0px;
  color: rgba(9, 122, 194, 1);
  .section {
    justify-content: flex-start;
    flex-direction: column;
    display: flex;
    padding: 10px;
    line-height: 0px;
  }
`;
export const StyledContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(50px, 1fr));

  .section {
    width: 100%;
  }
  .beneficiary-item {
    padding: 10px 10px 10px 0px;
    display: flex;
    align-items: flex-end;
    .item {
      padding-right: 5px;
    }
  }
`;
export const StyledInfoContent = styled.div`
  padding: 10px 20px 50px 0px;
`;
export const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .select {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
  .input {
    width: 327px;
    margin-bottom: 33px;
    margin-left: 24px;
    margin-right: 24px;
  }
`;
